const React = require('react');
const { default: Styled } = require('styled-components');

const UserInputs = require('components/UserInputs');
const BottomButtonContainer = require('components/BottomButtonContainer');
const PreventNavigationDialog = require('components/PreventNavigationDialog');
const GetQueryParams = require('utils/get-query-params');
const { analyticsTemplates } = require('utils/analytics');
const { ELEMENT_IDS } = require('utils/constants');

const internals = {};

const EditPage = module.exports = function EditPage(props) {

    const {
        useEffect
    } = React;

    const {
        history,
        ...userInputsProps
    } = props;

    const {
        Wrapper,
        FieldsWrapper
    } = internals;

    useEffect(() => {

        const scrollContainer = document.getElementById(ELEMENT_IDS.scrollContainer);

        if (scrollContainer) {
            scrollContainer.scrollTop = 0;
        }
    }, []);

    return (
        <UserInputs {...userInputsProps} mode='edit'>
            {({
                renderFields,
                uiState,
                submit
            }) => {
                const { confirm } = GetQueryParams();
                const alertMsg = confirm ? '' : 'You have made changes.\n Do you want to save or discard them?';

                return (
                    <Wrapper>
                        <BottomButtonContainer
                            btnLabel={confirm ? 'Confirm' : 'Save'}
                            onBtnClick={() => {

                                analyticsTemplates.buttons('save my profile', 'my profile: save my profile request');
                                submit({ shouldRedirect: true });
                            }}
                            disabled={uiState.submitting || uiState.uploadingProfilePic}
                        >
                            <PreventNavigationDialog
                                title={confirm && 'Please confirm your profile.'}
                                confirm={confirm}
                                saveFunction={() => {

                                    analyticsTemplates.buttons('save my profile', 'my profile: save my profile request');
                                    submit({ shouldRedirect: false });
                                }}
                                alertMsg={alertMsg}
                                when={!uiState.submitting && (confirm || uiState.pageIsBlocking)}
                                navigate={(path, locationState) => history.push(path, locationState)}
                                shouldBlockNavigation={() => {

                                    if (uiState.submitting) {
                                        return false;
                                    }

                                    if (confirm || uiState.pageIsBlocking || uiState.pageHasErrors) {
                                        return true;
                                    }

                                    return false;
                                }}
                                pageHasErrors={uiState.pageHasErrors}
                            />
                            {renderFields({ fieldsWrapper: FieldsWrapper })}
                        </BottomButtonContainer>
                    </Wrapper>
                );
            }}
        </UserInputs>
    );
};

internals.Wrapper = Styled.div`
    overflow: hidden;
    height: 100%;
`;

internals.FieldsWrapper = Styled.div`
    margin: 0 auto;
    padding: 1.5em;

    @media screen and (min-width: 360px) {
        max-width: 400px;
    }

    @media screen and (min-width: 600px) {
        max-width: 600px;
    }

    button:hover, div[role="button"]:hover {
        opacity: 0.9;

        & > div > div {
            background-color: initial !important;
            opacity: 1;
        }
    }
`;
